// React imports.
import React, { Component } from "react";

//library imports
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// App imports.
import ReadingIndexValues from "./ReadingIndexValues";


const BenefitTargetingComp1 = ({ history }) => {
  // Safety checks for potentially undefined values
  const latestYear = history.LatestYear || {};
  const fiscalYear = latestYear.Year || '';
  const natlAvgIndex = history.LatestYearNatlAvgIndex || 0;
  const avgPctDiffString = history.LatestYearAvgPctDiffString || '';

  let options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column',
    },
    title: {
      text: history.SelectedIndexString + ' Index'
    },
    xAxis: {
      labels: {
        enabled: true,
      },
      categories: [],
      crosshair: true
    },
    yAxis: {
      plotLines: [{
        color: '#FF0000',
        width: 2,
        value: 100,
        dashStyle: 'ShortDash',
      }],
      min: 0,
      max: 200,
      title: {
        text: history.SelectedIndexString + ' Index'
      }
    },
    series: [
      {
        name: history.SelectedIndexString + ' Index',
        data: [],
        showInLegend: false,
      }
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true
        }
      },
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
  };

  let dataArray = [];

  dataArray.push(natlAvgIndex);
  options.xAxis.categories.push("Average for all States");
  options.series[0].data = dataArray;

  if (+natlAvgIndex > 200) {
    options.yAxis.max = +natlAvgIndex + 30;
  }

  return (
    <div >
      <h2>{history.SelectedIndexString}    Index – Average Score for All States</h2>
      <br />
      <p>
        Now that you know more about your own {history.SelectedIndexString}  Index scores, let's see how they compare with other LIHEAP grantees.
      </p>
      <p>
        In {fiscalYear}, the  average {history.SelectedIndexString}  Index among all state  
        LIHEAP grantees was:
      </p>
      <div className="container">
        <div className="row">
          <div className="col-sm-5 font-weight-bold offset-sm-2 h5 text-right">AVERAGE FOR ALL STATES:</div>
          <div className="col-sm-3 font-weight-bold h5 text-left">{natlAvgIndex}</div>
        </div>
      </div>
      <br />
      This means that on average across the US, high burden LIHEAP households
      {avgPctDiffString}
      <br /><br />
      <div className="container">
        <div className="row">
          <div className="col-sm-7">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
          <div className="col-sm-5 takeaways">
            <ReadingIndexValues history={history} />
          </div>
        </div>
      </div>
      <br /><br />
      <p><span>Please click <em>Next </em>to continue.</span></p>
    </div>
  );
}
export default BenefitTargetingComp1;
